import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { ReservationCancellationReason } from './reservation-cancellation-reason.model';
import { ReservationCancellationReasonPopupService } from './reservation-cancellation-reason-popup.service';
import { ReservationCancellationReasonService } from './reservation-cancellation-reason.service';
import { School, SchoolService } from '../school';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { Principal } from '../../shared/index';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-reservation-cancellation-reason-dialog',
    templateUrl: './reservation-cancellation-reason-dialog.component.html'
})
export class ReservationCancellationReasonDialogComponent extends AbstractDialogComponent implements OnInit {

    reservationCancellationReason: ReservationCancellationReason;
    authorities: any[];
    isSaving: boolean;

    schools: School[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        alertService: AlertService,
        private reservationCancellationReasonService: ReservationCancellationReasonService,
        schoolService: SchoolService,
        private eventManager: EventManager,
        principal: Principal
    ) {
        super(schoolService, alertService, principal);
        this.jhiLanguageService.setLocations(['reservationCancellationReason']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.loadSchools();
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.reservationCancellationReason.id !== undefined) {
            this.reservationCancellationReasonService.update(this.reservationCancellationReason)
                .subscribe((res: ReservationCancellationReason) =>
                    this.onSaveSuccess(res), (res: HttpErrorResponse) => this.onSaveError(res));
        } else {
            this.reservationCancellationReasonService.create(this.reservationCancellationReason)
                .subscribe((res: ReservationCancellationReason) =>
                    this.onSaveSuccess(res), (res: HttpErrorResponse) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: ReservationCancellationReason) {
        this.eventManager.broadcast({ name: 'reservationCancellationReasonListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    trackSchoolById(index: number, item: School) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-reservation-cancellation-reason-popup',
    template: ''
})
export class ReservationCancellationReasonPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private reservationCancellationReasonPopupService: ReservationCancellationReasonPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.modalRef = this.reservationCancellationReasonPopupService
                    .open(ReservationCancellationReasonDialogComponent as Component, params['id']);
            } else {
                this.modalRef = this.reservationCancellationReasonPopupService
                    .open(ReservationCancellationReasonDialogComponent as Component);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-cancellation-reason/reservation-cancellation-reason-dialog.component.ts